import { useEffect, useRef } from 'react';
import { useAuth } from './Auth/AuthContext';
import { useData } from './Data/DataContext';
import { AuthStage } from './Auth/types';

/**
 * Diese Komponente wird einmalig beim App-Start ausgeführt und sorgt dafür,
 * dass die Daten aus dem Backend geladen werden und der Authentifizierungsstatus geprüft wird.
 */
const AppInitializer = () => {
  const { authData, checkAuthStatus } = useAuth();
  const { refreshData } = useData();
  const initializedRef = useRef(false);

  
  // Dieses useEffect wird nur einmal beim ersten Rendern der App ausgeführt
  useEffect(() => {
    if (!initializedRef.current) {
      console.log('AppInitializer: Erste Initialisierung');
      initializedRef.current = true;

      const initialize = async () => {
        console.log('AppInitializer: Initialisierung gestartet');
        // Authentifizierungsstatus prüfen
        await checkAuthStatus();
        // Initiales Laden der Daten
        await refreshData();
        console.log('AppInitializer: Initialisierung abgeschlossen');
      };

      initialize();
    }
  }, []);

  // Neuladen der Daten nach erfolgreicher Anmeldung
  useEffect(() => {
    if (authData.stage === AuthStage.AUTHENTICATED && initializedRef.current) {
      console.log('AppInitializer: Neue Anmeldung erkannt, lade Daten neu');
      refreshData();
    }
  }, [authData.stage]);

  return null; // Diese Komponente rendert nichts
};

export default AppInitializer;
